import React, { useContext, useRef } from "react";
import Modal from "react-bootstrap/Modal";

import "./Signature.css";
import { Table } from "react-bootstrap";
import { Context } from "../../../../utils/context";

const Signature = ({ show, onHide, setErr, signature }) => {
  const { IMG_URL } = useContext(Context);

  return (
    <Modal
      className="common_modal Service_History_modal"
      centered
      aria-labelledby="contained-modal-title-vcenter"
      show={show}
      onHide={onHide}
      size="lg">
      <Modal.Header closeButton>
        <Modal.Title>Signature</Modal.Title>
      </Modal.Header>
      <Modal.Body>
        {" "}
        <div style={{ textAlign: "center" }}>
          {signature ? (
            <img
              src={IMG_URL + signature}
              style={{
                width: "auto",
                height: "150px",
                borderRadius: "50px",
              }}></img>
          ) : (
            "No Image Uploaded"
          )}
        </div>
      </Modal.Body>
    </Modal>
  );
};

export default Signature;
